<template>
  <div v-show="dataLoaded">
    <section class="l-gap--xxxl p-articles-section">
      <h4 class="c-title-section-v2">
        <span class="text-eng">Voice</span>
        <span class="text">先輩たちの声</span>
      </h4>
      <div class="l-gap--md">
        <div class="p-archive-list u-position--relative">
          <div class="p-archive-slider p-archive-slider--portrait swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(post, index) in posts" :key="index">
                <article class="p-archive-item-portrait">
                  <div class="p-archive-item-portrait__inner">
                    <div class="p-archive-item-portrait__main">
                      <div class="p-archive-item-portrait__thumb c-media-thumb c-media-thumb--portrait">
                        <img v-if="post.vertical_image" :src="post.vertical_image" alt="" width="340" height="595">
                        <img v-else :src="post.image" alt="" width="340" height="595">
                      </div>
                      <header class="p-archive-item-portrait__header">
                        <h5 class="p-archive-item-portrait__title c-title-obi c-title-obi--small">
                          <span>{{ post.title }}</span>
                        </h5>
                        <span class="p-archive-item-portrait__categories">
                          <span class="p-archive-item-portrait__category c-title-obi c-title-obi--category"><span>{{
                            post.category }}</span></span>
                        </span>
                      </header>
                      <time class="p-archive-item-portrait__date" :datetime="post.createdAt"><span class="year">{{ new
                        Date(post.createdAt).getFullYear() }}</span><span class="date">{{ formatDate(post.createdAt) }}</span></time>
                    </div>
                    <div class="p-archive-item-portrait__modal-button" :aria-label="post.title + 'の動画を開く'"
                      data-micromodal-trigger="modal-movie" :data-movie-url="post.youtube_url">
                    </div>
                  </div>
                  <ul class="c-list-text-tags">
                    <li v-for="tag in post.tags" :key="tag.id"><a :href="'/media/blog_tag/' + tag.slug + '/'"
                        target="_blank">{{ tag.name }}</a></li>
                  </ul>
                </article>
              </div>
            </div>
          </div>
          <div class="p-nav-swiper-container u-visible--sm">
            <button type="button"
              class="p-nav-swiper-around-nav-block p-nav-swiper-around-nav-block__prev swiper-button-prev"
              aria-label="前へ">
              <span class="c-icon">
                <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/icon_arrow_circle.svg" alt="" width="60"
                  height="60" loading="lazy">
              </span>
            </button>
            <button type="button"
              class="p-nav-swiper-around-nav-block p-nav-swiper-around-nav-block__next swiper-button-next"
              aria-label="次へ">
              <span class="c-icon">
                <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/icon_arrow_circle.svg" alt="" width="60"
                  height="60" loading="lazy">
              </span>
            </button>
          </div>
        </div>
      </div>
      <span class="p-articles-section__deco-2">
        <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/deco13@2x.webp" alt="" width="344" height="222"
          loading="lazy">
      </span>
      <span class="p-articles-section__deco-3">
        <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/deco12@2x.webp" alt="" width="303" height="142"
          loading="lazy">
      </span>
    </section>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

import ArchiveSlider from './ArchiveSlider';
import MicroModal from 'micromodal';
import { micromodalSettings } from '../main.js';

// API
const posts = ref({});
const dataLoaded = ref(false);

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月を2桁にする
  const day = date.getDate().toString().padStart(2, '0'); // 日を2桁にする
  return `${month}${day}`;
};

const params = {
  taxonomy: 'movie_cat',
  category: 'nbl-voice',
  tag: 'nbl-web-marketing',
  perPage: 10,
};

const apiGet = async () => {
  const response = await api.get('/media/api/', { params });
  posts.value = response.data.posts;
};

onMounted(async () => {
  // コンポーネントがマウントされたときにapiGetメソッドを呼び出します
  await apiGet();
  if(posts.value.length > 0) {
  dataLoaded.value = true;
  const ArchiveSliderElem = document.querySelectorAll('#voice-web-marketing .p-archive-slider');
  if (!ArchiveSliderElem.length) return;
  for (let i = 0; i < ArchiveSliderElem.length; i++) {
    new ArchiveSlider(ArchiveSliderElem[i], i);
  }
  //micromodal実行
  MicroModal.init(micromodalSettings);

  //イベント発行があった場合は再度実行（主にSwiper）
  document.addEventListener('objInit', () => {
    let modalTimer;
    clearTimeout(modalTimer);
    modalTimer = setTimeout(() => {
      MicroModal.init(micromodalSettings);
    }, 200);
  });
  } else {
    dataLoaded.value = false;
  }

});
</script>
